import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconEdgeLeft24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconEdgeLeft24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M16.25 19a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-4 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2M3 17a.75.75 0 0 0 1.5 0V7A.75.75 0 0 0 3 7zm8.25-13a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-3 15a1 1 0 1 0 0 2 1 1 0 0 0 0-2M6.93 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0m8.32 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m5 11a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1-3a1 1 0 1 1 2 0 1 1 0 0 1-2 0m1-5a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconEdgeLeft24);
